import { MINERVA_API_URL, CONTENT_REPORTS_CONFIG } from '@/config';
import { http } from '@/plugins/http';
import types from './mutation-types';


export function setSelectedPreviewCard({ commit }, card) {
  commit(types.SET_SELECTED, card);

  return Promise.resolve();
}

export function setSelectedPreviewPageIndex({ commit }, pageIndex) {
  commit(types.SET_PAGE_INDEX, pageIndex);

  return Promise.resolve();
}

export function setIsStudentAssignmentPreview({ commit }, isStudentAssignmentPreview) {
  commit(types.SET_IS_STUDENT_PREVIEW, isStudentAssignmentPreview);

  return Promise.resolve();
}

export function setIsClassAssignmentPreview({ commit }, isClassAssignmentPreview) {
  commit(types.SET_IS_CLASS_PREVIEW, isClassAssignmentPreview);

  return Promise.resolve();
}

export function setIsPagePreview({ commit }, isPagePreview) {
  commit(types.SET_IS_PAGE_PREVIEW, isPagePreview);

  return Promise.resolve();
}

export function setBusy({ commit }, obj) {
  commit(types.SET_BUSY, obj);
}

export function setActiveEditorLocation({ commit }, editorLocation) {
  commit(types.SET_ACTIVE_EDITOR_LOCATION, editorLocation);

  return Promise.resolve(editorLocation);
}

export function setActiveEditorId({ commit }, editorId) {
  commit(types.SET_ACTIVE_EDITOR_ID, editorId);

  return Promise.resolve(editorId);
}

export function submitGoogleForms(_, params) {
  return http.post(`${MINERVA_API_URL}/google-forms`, params);
}

export function sendContentReportError(err = {}, params) {
  const body = {
    username: CONTENT_REPORTS_CONFIG.username,
    attachments: [{
      color: 'warning',
      mrkdwn_in: ['text'],
      text: `\`\`\`${JSON.stringify(err)}\`\`\`\n\n\`\`\`${JSON.stringify(params, null, '  ')}\`\`\``,
    }],
  };

  return http.post(CONTENT_REPORTS_CONFIG.url, JSON.stringify(body), {
    headers: { 'Content-Type': 'text/plain' },
    transformRequest: [(data, headers) => {
      /* eslint-disable no-param-reassign */
      delete headers.common.Authorization;
      delete headers.common['Country-Code'];
      return data;
      /* eslint-enable */
    }],
  });
}

export function sendContentReport(_, params) {
  return http.post(`${MINERVA_API_URL}/reports`, {
    target_type: 'page',
    target_id: params.page_id,
    reason: params.reason,
  })
    .catch((err) => {
      const { response } = err;
      sendContentReportError(response, params);
    });
}
